//Moveable
export const OPERATION_TYPE = { transform: 'transform', insert: 'insert', delete: 'delete' }

export const REVERS_OPERATION = {
  delete: 'delete',
  insert: 'insert',
  transform: 'transform'
}

export const MOVEABLE_INDICATORS = ['id', 'x', 'y', 'width', 'height', 'operationType']

export const MAX_WIDTH = 1493,
  MAX_HEIGHT = 850,
  MIN_WIDTH = 9,
  MIN_HEIGHT = 44;

export const createDeleteViewable = (componentInstance) => {
  return {
    name: "DeleteViewable",
    props: {},
    events: {},
    render: (moveable, render) => {
      const rect = moveable.getRect();
      const style = {
        position: "absolute",
        top: `${-23}px`,
        left: `${rect.width + 16}px`,
        borderRadius: "5px",
        background: componentInstance.validatePosisition ? "#44AAFF" : "#ff0000",
        padding: "0px 7px 3px 7px",
        color: "white",
        fontSize: "13px",
        whiteSpace: "nowrap",
        fontWeight: "500",
        willChange: "transform",
        transform: "translate(-50%, 0px)",
      };
      const props = {
        style,
        key: "delete-viewer",
        class: "moveable-delete",
        onClick: () => {
          componentInstance.deleteItem();
        },
      };
      const text = `x`; //❌//TODO: кнопка не рендерится через componentInstance
      componentInstance.current.width = rect.width;
      componentInstance.current.height = rect.height;
      return render.createElement("div", props, [text]);
    },
  };
};

export const COMPONENTS = [
  {
    typeName: "indicator",
    typeNameRu: "Индикатор",
    attrList: {
      x: 30,
      y: 10,
      width: 48,
      height: 22,
      hint: "",
      PropertyURI: "",
      round: null,
      fill: "white",
    },
    default: {
      width: 48,
      height: 20,
    },
  },
  {
    typeName: "state_interpreter",
    typeNameRu: "Переключатель",
    attrList: {
      x: 30,
      y: 40,
      width: 100,
      height: 22,
      hint: "",
      type: 1,
      PropertyURI: "",
      options: [],
    },
    default: {
      width: 140,
      height: 20,
    },
  },
  {
    typeName: "heading",
    typeNameRu: "Заголовок",
    attrList: {
      x: 30,
      y: 70,
      width: 100,
      height: 14,
      fill: "black",
      text_anchor: "start",
      hint: "",
      heading_caption: "Текст Текст"
    },
    default: {
      width: 100,
      height: 14,
    },
  },
  {
    typeName: "editor",
    typeNameRu: "Эдитор",
    attrList: {
      x: 30,
      y: 70,
      width: 80,
      height: 22,
      fill: "white",
      text_anchor: "start",
      hint: "",
      heading_caption: "",
      PropertyURI: "",
    },
    default: {
      width: 80,
      height: 20,
    },
  },
  {
    typeName: "valve",
    typeNameRu: "Клапан",
    attrList: {
      x: 30,
      y: 90,
      width: 36,
      height: 24,
      hint: "",
      PropertyURI: "",
      binary: false
    },
    default: {
      width: 72,
      height: 48,
    },
  },
  {
    typeName: "pipeline_horizontal",
    typeNameRu: "Труба горизонтальная",
    attrList: {
      x: 30,
      y: 120,
      width: 68,
      height: 12,
      hint: "",
      PropertyURI: "",
    },
    default: {
      width: 116,
      height: 24,
    },
  },
  {
    typeName: "pipeline_vertical",
    typeNameRu: "Труба вертикальная",
    attrList: {
      x: 30,
      y: 145,
      width: 10,
      height: 50,
      hint: "",
      PropertyURI: "",
    },
    default: {
      width: 24,
      height: 136,
    },
  },
  {
    typeName: "pipeline_90_rightup",
    typeNameRu: "Труба пр. вверх 90°",
    attrList: {
      x: 30,
      y: 220,
      width: 18,
      height: 18,
      hint: "",
      PropertyURI: "",
    },
    default: {
      width: 36,
      height: 36,
    },
  },
  {
    typeName: "pipeline_90_rightbottom",
    typeNameRu: "Труба пр. низ 90°",
    attrList: {
      x: 30,
      y: 250,
      width: 18,
      height: 18,
      hint: "",
      PropertyURI: "",
    },
    default: {
      width: 36,
      height: 36,
    },
  },
  {
    typeName: "pipeline_90_leftbottom",
    typeNameRu: "Труба вл. низ -90°",
    attrList: {
      x: 30,
      y: 250,
      width: 18,
      height: 18,
      hint: "",
      PropertyURI: "",
    },
    default: {
      width: 36,
      height: 36,
    },
  },
  {
    typeName: "pipeline_90_leftup",
    typeNameRu: "Труба вл. вверх -90°",
    attrList: {
      x: 30,
      y: 250,
      width: 18,
      height: 18,
      hint: "",
      PropertyURI: "",
    },
    default: {
      width: 36,
      height: 36,
    },
  },
  {
    typeName: "pipeline_cross",
    typeNameRu: "Труба пересечение",
    attrList: {
      x: 30,
      y: 250,
      width: 26,
      height: 26,
      hint: "",
      PropertyURI: "",
    },
    default: {
      width: 70,
      height: 70,
    },
  },
  {
    typeName: "drawing",
    typeNameRu: "Иконка SVG",
    attrList: {
      x: 30,
      y: 280,
      width: 40,
      height: 32,
      hint: "",
      src: "meter.svg",
    },
    default: {
      width: 50,
      height: 40,
    },
  },
  {
    typeName: "icon",
    typeNameRu: "Иконка PNG",
    attrList: {
      x: 30,
      y: 280,
      width: 40,
      height: 32,
      hint: "",
      src: "0.png",
    },
    default: {
      width: 50,
      height: 40,
    },
  },
  {
    typeName: "cool_pump",
    typeNameRu: "Вентилятор",
    attrList: {
      x: 30,
      y: 330,
      width: 44,
      height: 37,
      hint: "",
      PropertyURI: "",
      binary: false
    },
    default: {
      width: 88,
      height: 75,
    },
  },
  {
    typeName: "panel",
    typeNameRu: "Панель",
    attrList: {
      x: 30,
      y: 375,
      width: 60,
      height: 40,
      hint: "",
      PropertyURI: "",
      fill: "#e4e4e4ff"
    },
    default: {
      width: 146,
      height: 100,
    },
  },
  {
    typeName: "progressbar",
    typeNameRu: "Прогресс Бар",
    attrList: {
      x: 30,
      y: 375,
      width: 28,
      height: 40,
      hint: "",
      PropertyURI: "",
      type: 2,
      fill: "blue",
    },
    default: {
      width: 36,
      height: 90,
    },
  },
  {
    typeName: "tank",
    typeNameRu: "Емкость",
    attrList: {
      x: 30,
      y: 375,
      width: 40,
      height: 28,
      hint: "",
      PropertyURI: "",
      type: '0',
      fill: "blue",
    },
    default: {
      width: 193,
      height: 80,
    },
  },
  {
    typeName: "tank_double_level",
    typeNameRu: "Емкость с нефтью",
    attrList: {
      x: 30,
      y: 375,
      width: 40,
      height: 28,
      hint: "",
      PropertyURI: "",
      type: 0,
    },
    default: {
      width: 193,
      height: 80,
    },
  },
  {
    typeName: "button_",
    typeNameRu: "Кнопка",
    attrList: {
      x: 30,
      y: 70,
      width: 56,
      height: 24,
      fill: "gray",
      hint: "",
      heading_caption: "Кнопка",
      viewBox: false,
      function: () => {
        console.log('click button_');
      },
    },
    default: {
      width: 56,
      height: 24,
    },
  },
  {
    typeName: "input_",
    typeNameRu: "Ввод",
    attrList: {
      x: 30,
      y: 70,
      width: 80,
      height: 22,
      hint: "",
      PropertyURI: "",
    },
    default: {
      width: 80,
      height: 20,
    },
  },
  {
    typeName: "dropdown_",
    typeNameRu: "Дропдаун",
    attrList: {
      x: 0,
      y: 0,
      width: 90,
      height: 22,
      options: [],
      PropertyURI: "",
    },
    default: {
      width: 80,
      height: 20,
    },
  },
  {
    typeName: "scnd",
    typeNameRu: "ЦНС",
    attrList: {
      x: 30,
      y: 250,
      width: 68,
      height: 30,
      hint: "",
      PropertyURI: "",
      binary: false
    },
    default: {
      width: 230,
      height: 82,
    },
  },
  {
    typeName: "submersibl_pump",
    typeNameRu: "Погружной насос",
    attrList: {
      x: 30,
      y: 250,
      width: 38,
      height: 60,
      hint: "",
      PropertyURI: "",
    },
    default: {
      width: 84,
      height: 147,
    },
  },
  {
    typeName: "vert_pump",
    typeNameRu: "Верт. насос",
    attrList: {
      x: 30,
      y: 250,
      width: 20,
      height: 50,
      hint: "",
      PropertyURI: "",
    },
    default: {
      width: 42,
      height: 118,
    },
  },
  {
    typeName: "line_",
    typeNameRu: "Линия",
    attrList: {
      x: 30,
      y: 250,
      width: 100,
      height: 4,
      hint: "",
      PropertyURI: "",
      fill: '#343638'
    },
    default: {
      width: 150,
      height: 6,
    },
  },
  {
    typeName: "sign",
    typeNameRu: "Табличка",
    attrList: {
      x: 30,
      y: 10,
      width: 48,
      height: 48,
      heading_caption: "ГАЗ",
      PropertyURI: "",
      round: null,
      type: 1,
      fill: "red",
    },
    default: {
      width: 48,
      height: 48,
    },
  },
];
